import { authService } from '../../services/authService'
import * as actionTypes from './ActionTypes'
import { clearCompanyRedux } from './Company'
import { clearConversationsRedux } from './Conversations'

export const loginSuccess = token => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    payload: {
      token,
    },
  }
}

export const logoutSuccess = () => {
  return {
    type: actionTypes.LOGOUT_SUCCESS,
  }
}

export const getUserInfoSuccess = userInfo => {
  return {
    type: actionTypes.GET_USER_INFO_SUCCESS,
    payload: { userInfo },
  }
}

export const logout = () => async dispatch => {
  const logoutResponse = await authService.logout()
  if (logoutResponse.isOk) {
    dispatch(logoutSuccess())
    dispatch(clearCompanyRedux())
    dispatch(clearConversationsRedux())
  }
  return logoutResponse.isOk
}

export const getUserInfo =
  ({ userId = null }) =>
  async dispatch => {
    const response = await authService.getUserInfo({ userId })
    if (response.isOk) {
      dispatch(getUserInfoSuccess(response.data))
    }
  }
